import type { App, DirectiveBinding } from 'vue'
import { Plugin } from 'vue'
import { useNotificationStore } from '@/store/notification'

interface HTMLElementWithClickOutside extends HTMLElement {
  clickOutsideEvent?: (event: Event) => void
}

interface HTMLCopy extends HTMLElement {
  copyEvent?: () => void
}

const clickOutsideMethod = {
  mounted: (el: HTMLElementWithClickOutside, binding: DirectiveBinding) => {
    el.clickOutsideEvent = function (event: Event) {
      const target = event.target
      if (target instanceof Node) {
        if (!(el == event.target || el.contains(target))) {
          binding.value()
        }
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unmounted: (el: HTMLElementWithClickOutside) => {
    document.body.removeEventListener('click', el.clickOutsideEvent!)
  },
}

const copyMethod = {
  mounted: (el: HTMLCopy, binding: DirectiveBinding) => {
    const { addNotification } = useNotificationStore()
    el.copyEvent = async function () {
      await navigator.clipboard.writeText(binding.value)
      addNotification({
        type: 'success',
        content: 'Copied!',
        withTimer: false,
      })
    }
    el.addEventListener('click', el.copyEvent)
  },
}

const InitDirective: Plugin<[]> = {
  async install(vue: App) {
    vue.directive('click-outside', clickOutsideMethod)
    vue.directive('copy', copyMethod)
  },
}

export default InitDirective
